// Serbian (latinica) dictionary, keyed by the English UI string.
// Split by app area so parallel work never touches the same file.
import { common } from './common';
import { nav } from './nav';
import { feed } from './feed';
import { auth } from './auth';
import { discover } from './discover';
import { notifications } from './notifications';
import { settings } from './settings';
import { profile } from './profile';
import { channels } from './channels';
import { leaderboard } from './leaderboard';
import { portfolio } from './portfolio';
import { watchlist } from './watchlist';
import { battles } from './battles';
import { referral } from './referral';
import { inbox } from './inbox';
import { live } from './live';
import { misc } from './misc';
import { forum } from './forum';
import { landing } from './landing';
import { premium } from './premium';
import { onboarding } from './onboarding';
import { engagement } from './engagement';

export const sr: Record<string, string> = {
  ...common,
  ...nav,
  ...feed,
  ...auth,
  ...discover,
  ...notifications,
  ...settings,
  ...profile,
  ...channels,
  ...leaderboard,
  ...portfolio,
  ...watchlist,
  ...battles,
  ...referral,
  ...inbox,
  ...live,
  ...misc,
  ...forum,
  ...landing,
  ...premium,
  ...onboarding,
  ...engagement,
};
